// useApi.js
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ParseJwt from '../../tokenComponent';
import axios from 'axios';

const useProfile = (token, user) => {

  const url = `${process.env.REACT_APP_API}/api/user`;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [profile, setProfile] = useState(null);

  const fetchUser = () => {
     axios
       .get(`${url}/${user.userId}`, {
         headers: { authorization: `Bearer ${token}` },
       })
       .then((response) => {
         setLoading(false);
         setProfile(response.data);
       });
  };


  useEffect(() => {
      if (token && user) {
        const decodedJwt = ParseJwt(token);
        if (decodedJwt.exp * 1000 <= Date.now()) {
          return navigate(-1);
        }
    }
    fetchUser();
  }, []);

  return { loading, profile };
};

export default useProfile;
